import { render, staticRenderFns } from "./loginTransfer.vue?vue&type=template&id=41697912&scoped=true&"
import script from "./loginTransfer.vue?vue&type=script&lang=js&"
export * from "./loginTransfer.vue?vue&type=script&lang=js&"
import style0 from "./loginTransfer.vue?vue&type=style&index=0&id=41697912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41697912",
  null
  
)

export default component.exports